<template>
	<div class="container">
		<myHeader></myHeader>
		<div class="main" v-loading="loading" element-loading-text="加载中 ...">
			<div class="banner">
				<img v-if="getTypeId == 1" src="../assets/banner/developmentPlan_banner.jpg" />
				<img v-if="getTypeId == 2" src="../assets/banner/job_banner.jpg" />
				<img v-if="getTypeId == 3" src="../assets/banner/building_banner.jpg" />
				<img v-if="getTypeId == 4" src="../assets/banner/zhinan_banner.jpg" />
				<img v-if="getTypeId == 5" src="../assets/banner/vr_banner.jpg" />
			</div>
			<div class="article-list" v-if="getTypeId == 1">
				<div class="item" v-for="(item, index) in dataList" :key="index"
					@click="toArticleDetail(item.articleId)">
					<div class="title">
						{{ item.articleTitle }}
					</div>
					<div class="info">
						<span>{{ item.articlePublishTime }}</span>
					</div>
				</div>
				<div class="more-list" v-if="isMore" @click="loadMore()">查看更多</div>
				<div class="more-list" v-if="noMore">没有更多</div>
			</div>
			<div class="recruit-list" v-if="getTypeId == 2">
				<div class="item" v-for="(item, index) in dataList" :key="index"
					@click="toArticleDetail(item.articleId, item.articleLinks)">
					<div class="left">
						<img src="../assets/images/rczp_icon.png" />
					</div>
					<div class="center">
						<div class="title">
							{{ item.articleTitle }}
						</div>
						<div class="info">
							<span>{{ item.articlePublishTime }}</span>
						</div>
					</div>
					<div class="right">
						<img src="../assets/images/more.png" />
					</div>
				</div>
				<div class="more-list" v-if="isMore" @click="loadMore()">查看更多</div>
				<div class="more-list" v-if="noMore">没有更多</div>
			</div>
			<div class="building-list" v-if="getTypeId == 3">
				<div class="item" v-for="(item, index) in dataList" :key="index"
					@click="toArticleDetail(item.articleId)">
					<div class="left">
						<img :src="baseUrl+item.articleImg" />
					</div>
					<div class="right">
						<div class="title">
							{{ item.articleTitle }}
						</div>
						<div class="more">
							<el-button type="primary" plain round>查看更多</el-button>
						</div>
					</div>
				</div>
				<div class="more-list" v-if="isMore" @click="loadMore()">查看更多</div>
				<div class="more-list" v-if="noMore">没有更多</div>
			</div>
			<div class="download-list" v-if="getTypeId == 4">
				<div class="item" v-for="(item, index) in dataList" :key="index" @click="toWebLink(item.articleLinks)">
					<div class="title">
						{{ item.articleTitle }}
					</div>
					<div class="info">
						<el-tag class="tags" type="" effect="dark">电子书</el-tag>
						<el-tag class="tags" type="info" effect="plain">PPT</el-tag>
						<el-tag class="tags" type="info" effect="plain">PDF</el-tag>
					</div>
					<div class="img">
						<img :src="baseUrl+item.articleImg" style="width: 100%;" />
					</div>
					<div class="date">
						更新时间：{{ item.articlePublishTime }}
					</div>
				</div>
				<div class="more-list" v-if="isMore" @click="loadMore()">查看更多</div>
				<div class="more-list" v-if="noMore">没有更多</div>
			</div>
			<div class="vr-list" v-if="getTypeId == 5">
				<div class="item" v-for="(item, index) in dataList" :key="index">
					<div class="title">
						{{ item.articleTitle }}
					</div>
					<div class="info">
						<img class="img" :src="baseUrl+item.articleImg" />
						<div class="tip">
							点击下方进入实景VR
						</div>
						<el-tag v-for="(items, indexs) in item.cdmapArticleTagList" :key="indexs" @click="toWebLink(items.articleTagUrl)" class="tags" size="large" effect="dark">
							{{ items.articleTagName }}
						</el-tag>
					</div>
				</div>
				<div class="more-list" v-if="isMore" @click="loadMore()">查看更多</div>
				<div class="more-list" v-if="noMore">没有更多</div>
			</div>
		</div>
		<!-- 尾部 -->
		<myFooter></myFooter>
		<!-- 侧边悬浮 -->
		<sideFloat></sideFloat>
		<!-- 底部菜单 -->
		<bottomMenu></bottomMenu>
	</div>
</template>

<script>
	import {
		useRoute,
		useRouter
	} from 'vue-router'
	import {
		ref,
		defineComponent
	} from 'vue'
	import {
		ElMessage
	} from 'element-plus'
	import myHeader from '@/components/layouts/myHeader'
	import myFooter from '@/components/layouts/myFooter'
	import bottomMenu from '@/components/layouts/bottomMenu'
	import sideFloat from '@/components/layouts/sideFloat'
	import {
		getArticleList
	} from '@/axios/api'
	export default defineComponent({
		components: {
			myHeader,
			myFooter,
			bottomMenu,
			sideFloat
		},
		setup() {
			const route = useRoute();
			const router = useRouter();
			const baseUrl = 'https://ysdtapi.cdssjj.changde.gov.cn/cdMapApi';
			const loading = ref(true);
			const getTypeId = ref(0);
			const dataList = ref('');
			const step = ref(10); //每次增加数量
			const count = ref(10); //初始化当前显示数量
			const isMore = ref(true);
			const noMore = ref(false);
						
			(function getListData() {
				getData();
				// 当前显示数量存入session
				sessionStorage.setItem('count', count.value);
			})();

			// 点击加载更多
			function loadMore() {
				// 当前显示数量
				count.value = parseInt(sessionStorage['count']) + step.value;
				// 当前显示数量存入session
				sessionStorage.setItem('count', count.value);
				getData();
			}


			function getData() {
				getTypeId.value = route.query.typeId
				getArticleList('/cdMapApi/api/article/list', {
					typeId: route.query.typeId
				}).then(function(res) {
					let {
						code,
						data,
						msg
					} = res.data;
					if (code == 200) {
						loading.value = false;
						console.log('data:',data);
						// 当前渲染数据列表
						dataList.value = data.slice(0, count.value)
						if (count.value >= data.length) {
							isMore.value = false
							noMore.value = true
						}

					} else {
						ElMessage({
							offset: 100,
							type: 'error',
							message: msg
						});
					}
				})
			}
			
			// 资料下载跳转
			function toWebLink(url) {
				router.push({
					name: 'webLink',
					query: {
						url: url
					}
				})
				// window.location.href = url
			}

			// 列表跳转路由
			function toArticleDetail(articleId, url) {
				if(url) {
					window.location.href = url
				} else {
					router.push({
						name: 'articleDetail',
						query: {
							articleId: articleId
						}
					})
				}
			}

			return {
				loading,
				baseUrl,
				getTypeId,
				isMore,
				noMore,
				loadMore,
				dataList,
				toWebLink,
				toArticleDetail
			}
		}
	})
</script>

<style lang="scss" scoped>
	.container {
		height: auto;
		min-height: 100vh;
		margin: 0;
		padding: 0;

		.main {
			.banner {
				width: 100%;
				margin-bottom: 10px;
				overflow: hidden;

				img {
					width: 100%;
				}
			}

			.article-list {
				padding: 0px 10px;

				.item {
					background: #fff;
					padding: 10px;
					border-bottom: #e9e9e9 1px dashed;

					.title {
						font-size: 16px;
						line-height: 25px;
						text-align: left;
						color: #333;
						word-wrap: break-word;
					}

					.info {
						display: flex;
						justify-content: space-between;
						padding: 5px 0px;
						color: #999;
					}
				}
				
				.more-list {
					line-height: 50px;
					text-align: center;
				}
			}


			.building-list {
				padding: 0px 10px;

				.item {
					display: flex;
					justify-content: space-between;
					align-items: center;
					background: #fff;
					padding: 10px;
					border-bottom: #e9e9e9 1px dashed;

					.left {
						width: 120px;
						height: 80px;

						img {
							width: 120px;
							height: 80px;
						}
					}

					.right {
						width: calc(100% - 120px);
						margin-left: 15px;

						.title {
							font-size: 16px;
							text-align: left;
							color: #333;
							word-wrap: break-word;
							margin-bottom: 10px;
						}

						.more {
							height: 30px;
							line-height: 30px;
							color: #999;
						}
					}
				}
				
				.more-list {
					line-height: 50px;
					text-align: center;
				}
			}

			.recruit-list {
				padding: 0px 10px;

				.item {
					display: flex;
					justify-content: space-between;
					align-items: center;
					background: #fff;
					padding: 10px;
					border-bottom: #e9e9e9 1px dashed;

					.left {
						width: 50px;
						height: 50px;

						img {
							width: 50px;
							height: 50px;
						}
					}

					.center {
						width: calc(100% - 85px);
						margin-left: 15px;

						.title {
							font-size: 16px;
							height: 30px;
							line-height: 30px;
							overflow: hidden;
							text-align: left;
							color: #333;
							word-wrap: break-word;
						}

						.info {
							display: flex;
							justify-content: space-between;
							height: 20px;
							line-height: 20px;
							color: #999;
						}
					}

					.right {
						width: 30px;
						height: 30px;

						img {
							width: 30px;
							height: 30px;
						}
					}
				}
				
				.more-list {
					line-height: 50px;
					text-align: center;
				}
			}

			.download-list {
				padding: 0px 10px;

				.item {
					padding: 10px;
					border-bottom: #e9e9e9 1px solid;

					.title {
						font-size: 18px;
						line-height: 30px;
					}

					.info {
						margin: 5px 0px;

						.tags {
							margin-right: 10px;
						}
					}

					.img {
						img {
							width: 100%;
						}
					}

					.date {
						font-size: 14px;
						color: #636363;
						line-height: 30px;
					}
				}
				
				.more-list {
					line-height: 50px;
					text-align: center;
				}
			}

			.vr-list {
				padding: 0px 15px;

				.item {
					padding-bottom: 15px;
					margin-bottom: 15px;
					border-bottom: #e0e0e0 1px solid;
					
					.title {
						line-height: 40px;
						font-size: 20px;
						font-weight: bold;
					}
					.info {
						.img {
							width: 100%;
							margin-bottom: 5px;
						}
						.tip {
							margin-bottom: 10px;
							font-size: 14px;
						}
						.tags {
							margin: 0px 10px 10px 0px;
							padding: 10px 20px;
							font-size: 14px;
							font-weight: bold;
						}
						
					}
				}
				
				.more-list {
					line-height: 50px;
					text-align: center;
				}
			}
		}
	}
</style>